import { setupStimulus } from '@blueberry/framework/setup_stimulus'
import { storeAndClearProhibitedQueryParams } from './lib/query_param_utils'

setupStimulus(
  import.meta.glob(
    [
      './controllers/*_controller.ts',
      '@blueberry/controllers/modal_controller.ts',
      '@blueberry/controllers/phone_controller.ts',
      '@blueberry/controllers/apple-signin_controller.ts',
    ],
    { eager: true },
  ),
)

// These query params are stripped before the Meta pixel fires to prevent
// leaking health-related intent data (e.g. search keywords, condition-specific
// promos) to Facebook, which violates Meta's health data policies and FTC rules.
const FACEBOOK_PROHIBITED_QUERY_PARAMS = ['promo', 'design', 'ref', 'nb_kwd']
storeAndClearProhibitedQueryParams(FACEBOOK_PROHIBITED_QUERY_PARAMS)

window.addEventListener("turbo:frame-missing", (response) => {
  const targetFrameId = response.target.id
  response.detail.visit(`/bbjoin/fatal_error?target_frame=${targetFrameId}`, { frame: targetFrameId })
})
